module.exports = __webpack_public_path__ + "static/media/bank_detais_bg.410d1f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank_detais_bg.png
// module id = 1112
// module chunks = 21